import {devToolsEnhancer} from 'redux-devtools-extension';
import {createStore, combineReducers} from 'redux';

//Reducers
import i18nReducer from 'features/i18n/reducers';
import authentication from 'features/login/reducers';
import assistants from 'features/instance-manager/reducer/assistantsReducer';
import courseReducer from 'features/edit-course/reducer';
import profiles from 'features/edit-course/requirement/reducer';
import UpdateGridReducer from 'features/tablet-course/reducer';
import TabletCourseReducer from 'features/capacitation/component/reducer';
import NotificationReducer from 'features/navigation/reducer';
import gridReducer from 'components/grid-dx/reducer/gridReducer';

var rootReducer = combineReducers({
  i18nReducer,
  authentication,
  courseReducer,
  assistants,
  profiles,
  UpdateGridReducer,
  TabletCourseReducer,
  NotificationReducer,
  gridReducer,
});

export default createStore(
  rootReducer,
  devToolsEnhancer(),
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
);
